/*
 * Griffe & Cime — visionneuse de photos (snippet gc-visionneuse). Vanilla, chargé en defer.
 *
 * - Un clic sur un lien [data-gc-agrandir] agrandit la photo dans la fenêtre <dialog> de la page
 *   au lieu d'ouvrir l'image : croix pour fermer, Échap, clic à côté de la photo.
 * - Les liens qui partagent data-gc-groupe forment une suite : flèches et touches ← →.
 * - Clic avec Ctrl, Cmd, Maj ou molette : comportement normal du lien.
 * - À la fermeture, le focus revient sur la vignette cliquée (contour visible si ouverte au clavier).
 * Aucun texte affiché n'est écrit ici : tout vient des attributs rendus par le snippet.
 */
(() => {
  'use strict';

  const GC = (window.GC = window.GC || {});
  if (GC.visionneuse) return;

  let dialogue = null;
  let image = null;
  let compteur = null;
  let boutonsPas = [];
  let groupe = [];
  let index = 0;
  let declencheur = null;
  let auClavier = false;

  function preparer() {
    if (dialogue) return true;
    dialogue = document.querySelector('[data-gc-visionneuse]');
    if (!dialogue || typeof dialogue.showModal !== 'function') {
      dialogue = null;
      return false;
    }
    // L'image n'est créée qu'à la première ouverture (pas d'image vide dans la page avant).
    image = document.createElement('img');
    image.className = 'gc-visionneuse__image';
    image.decoding = 'async';
    dialogue.querySelector('[data-gc-visionneuse-figure]').prepend(image);
    compteur = dialogue.querySelector('[data-gc-visionneuse-compteur]');
    boutonsPas = Array.from(dialogue.querySelectorAll('[data-gc-visionneuse-pas]'));

    dialogue.querySelector('[data-gc-visionneuse-fermer]').addEventListener('click', () => dialogue.close());
    boutonsPas.forEach((bouton) => {
      bouton.addEventListener('click', () => afficher(index + Number(bouton.dataset.gcVisionneusePas)));
    });
    // Clic à côté de la photo (voile ou marges de la fenêtre) : fermeture.
    dialogue.addEventListener('click', (evenement) => {
      if (evenement.target === dialogue || evenement.target.classList.contains('gc-visionneuse__figure')) dialogue.close();
    });
    dialogue.addEventListener('keydown', (evenement) => {
      if (groupe.length < 2) return;
      if (evenement.key === 'ArrowLeft') afficher(index - 1);
      if (evenement.key === 'ArrowRight') afficher(index + 1);
    });
    dialogue.addEventListener('close', () => {
      document.documentElement.classList.remove('gc-visionneuse-ouverte');
      // Contour de focus seulement si la photo a été ouverte au clavier.
      if (declencheur && document.contains(declencheur)) declencheur.focus({ preventScroll: true, focusVisible: auClavier });
      declencheur = null;
    });
    return true;
  }

  function afficher(nouvelIndex) {
    index = (nouvelIndex + groupe.length) % groupe.length;
    const lien = groupe[index];
    image.classList.remove('gc-visionneuse__image--prete');
    image.alt = lien.dataset.alt || '';
    const montrer = () => image.classList.add('gc-visionneuse__image--prete');
    image.onload = montrer;
    image.onerror = montrer;
    image.src = lien.href;
    if (image.complete && image.naturalWidth) montrer();
    const plusieurs = groupe.length > 1;
    boutonsPas.forEach((bouton) => { bouton.hidden = !plusieurs; });
    compteur.hidden = !plusieurs;
    if (plusieurs) {
      compteur.textContent = (compteur.dataset.texte || '')
        .replace('[n]', String(index + 1))
        .replace('[t]', String(groupe.length));
    }
  }

  function ouvrir(lien, clavier = false) {
    if (!preparer()) return false;
    const nom = lien.dataset.gcGroupe;
    groupe = nom
      ? Array.from(document.querySelectorAll('a[data-gc-agrandir]')).filter((a) => a.dataset.gcGroupe === nom)
      : [lien];
    declencheur = lien;
    auClavier = clavier;
    afficher(Math.max(0, groupe.indexOf(lien)));
    document.documentElement.classList.add('gc-visionneuse-ouverte');
    dialogue.showModal();
    return true;
  }

  document.addEventListener('click', (evenement) => {
    const lien = evenement.target.closest('a[data-gc-agrandir]');
    if (!lien || evenement.button !== 0 || evenement.ctrlKey || evenement.metaKey || evenement.shiftKey || evenement.altKey) return;
    if (ouvrir(lien, evenement.detail === 0)) evenement.preventDefault();
  });

  GC.visionneuse = { ouvrir };
})();
